import * as React from "react";

function SvgPardotbySalesforce(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        fill="#6A747C"
        d="M6.306 7.462c-4.25 3.433-6.307 6.64-6.307 6.64l7.793 6.879C5.433 15.776 8.975 7.618 8.975 7.618a33.123 33.123 0 00-2.669-.156"
      />
      <path
        fill="#F89820"
        d="M20.005 12.608c.283-.609.575-1.196.873-1.765-5.813-2.525-7.812-2.204-7.812-2.204-3.711 12.939 3.639 21.199 3.639 21.199s-.73-8.543 3.3-17.23"
      />
      <path
        fill="#6A747C"
        d="M26.735 0c-5.978.398-11.292 1.596-16.046 4.416 0 0 7.952-.31 12.413 2.599C25.211 2.904 26.735 0 26.735 0"
      />
      <path
        fill="#F89820"
        d="M23.148 7.044c-1.126 1.153-1.706 2.532-2.316 3.906 2.8 1.778 2.517 4.061 1.998 4.988-.564 1.015-2.241 1.211-2.241 1.211-.773 1.563-1.019 3.974-1.019 3.974s3.897.028 5.755-2.154c2.284-2.686 2.993-7.129-1.047-11.028a7.643 7.643 0 00-1.13-.897"
      />
    </svg>
  );
}

export default React.forwardRef(SvgPardotbySalesforce);
